<template>
    <div style="">
        <div @click="changeConfirmState" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 10; display: flex; justify-content: center; align-items: center;">
            <div @click.stop="() => {}" style="width: calc(100% - 24px); background-color: #fff; border-radius: 24px; padding: 22px 12px;">
                <template v-if="type === INSTA_POPUP_TYPE.METHOD">
                    <div style="font-weight: 700; font-size: 20px; line-height: 28px;">인스타그램 이벤트 참여 방법</div>
                    <div style="margin-top: 30px;">
                        <div style="display: flex; align-items: center; gap: 10px;">
                            <div>
                                <img style="width: 18px;" :src="require('@/assets/img/insta_1.png')" alt="">
                            </div>
                            <div style="font-weight: 700; font-size: 12px; line-height: 24px; color: #808080;">인스타그램 앱을 열고 스토리에 본인의 훈련 영상을 올려주세요.</div>
                        </div>
                        <div style="display: flex; align-items: center; gap: 10px; margin-top: 12px;">
                            <div>
                                <img style="width: 18px;" :src="require('@/assets/img/insta_2.png')" alt="">
                            </div>
                            <div style="font-weight: 700; font-size: 12px; line-height: 24px; color: #808080;">스토리에 <span style="color: var(--color-main);"> @soccerhow_official </span>계정을 꼭 태그해주세요.</div>
                        </div>
                        <div style="display: flex; align-items: center; gap: 10px; margin-top: 12px;">
                            <div>
                                <img style="width: 18px;" :src="require('@/assets/img/insta_3.png')" alt="">
                            </div>
                            <div style="font-weight: 700; font-size: 12px; line-height: 24px; color: #808080;">업로드 된 스토리 화면을 캡쳐한 뒤 어플에 첨부해주시면 끝!</div>
                        </div>
                    </div>
                    <div @click="confirm" style="margin-top: 20px;" class="common_btn">확인했어요</div>
                </template>
                <template v-if="type === INSTA_POPUP_TYPE.CONFIRM">
                    <div style="text-align: center;">
                        <div>
                            <img style="width: 36px;" :src="require('@/assets/img/insta_imoji_glass.png')" alt="">
                        </div>
                        <div style="margin-top: 20px; font-weight: 700; font-size: 20px; line-height: 28px;">인스타그램 이벤트 참여<br>확인중입니다!</div>
                        <div style="margin-top: 10px; color: #808080; line-height: 24px; font-size: 14px; font-weight: 500;">제출해주신 인증 사진을 관리자가 확인하고 있어요.<br>
                            확인이 완료되면 곧바로
                            <span style="color: var(--color-main); font-weight: 700;">입단 요청서 작성 기회</span>
                            를 열어드릴게요!
                        </div>
                        <div @click="confirm" style="margin-top: 20px;" class="common_btn">확인했어요</div>
                    </div>
                </template>
                <template v-if="type === MEMBER_POPUP_TYPE.INSTARGRAM_CERTIFIED">
                    <div style="text-align: center;">
                        <div>
                            <img style="width: 40px;" :src="require('@/assets/img/insta_emoji_smile.png')" alt="">
                        </div>
                        <div style="margin-top: 20px; font-weight: 700; font-size: 20px; line-height: 28px;">인스타그램 이벤트 미션을<br>성공했어요!</div>
                        <div style="margin-top: 10px; color: #808080; line-height: 24px; font-size: 14px; font-weight: 500;">
                            축구선수가 되고 싶다면  입단 요청서를 작성해보세요. <br>
                            수많은 구단과 감독님께 나를 확실히 어필할 수 있습니다
                        </div>
                        <div @click="showRequestWriteForm" style="margin-top: 20px;" class="common_btn">입단 요청서 작성하기</div>
                        <div @click="changeConfirmState" style="margin-top: 20px; color: #808080; line-height: 24px; font-size: 14px; font-weight: 500; text-decoration: underline;">조금 더 둘러보기</div>
                    </div>
                </template>
                <template v-if="type === MEMBER_POPUP_TYPE.INSTARGRAM_REJECTED">
                    <div style="text-align: center;">
                        <div>
                            <img style="width: 40px;" :src="require('@/assets/img/reject_emoji.png')" alt="">
                        </div>
                        <div style="margin-top: 10px; font-weight: 700; font-size: 20px; line-height: 28px;">앗, 이벤트 인증이 반려되었어요</div>
                        <div style="margin-top: 5px; line-height: 20px; font-size: 14px; font-weight: 500;">저희가 안내드린 조건이랑 다른 이미지를 올려주신 것 같아요</div>
                        <div style="margin-top: 10px; color: #808080; line-height: 20px; font-weight: 500; font-size: 12px;">
                            사커하우 훈련 영상을 따라 촬영한 뒤 어플에 업로드해주세요.<br>
                            이후 Instagram 스토리에 올리고<br>
                            <span style="font-weight: 700; color: var(--color-main);">@soccerhow_official 계정을 태그</span> 후 업로드 하시고,<br>
                            해당 화면을 캡쳐해 다시 첨부해주시면 됩니다.
                        </div>
                        <div @click="changeConfirmState" style="margin-top: 20px;" class="common_btn">확인</div>
                    </div>
                </template>
                <template v-if="type === MEMBER_POPUP_TYPE.SOCCERHOW_DELETE_WITH_REASON">
                    <div style="text-align: center;">
                        <div>
                            <img style="width: 40px;" :src="require('@/assets/img/reject_emoji.png')" alt="">
                        </div>
                        <div style="margin-top: 10px; font-weight: 700; font-size: 20px; line-height: 28px;">앗, 입단 요청서가 반려되었어요</div>
                        <div style="margin-top: 5px; line-height: 20px; font-size: 14px; font-weight: 500;">감독님들께 확실한 실력을 보여드리기엔<br>조금 아쉬운 부분이 있어요.</div>
                        <div style="margin-top: 10px; color: #808080; font-size: 12px; line-height: 20px;">아래 내용을 보완해서 다시 도전해볼까요?</div>
                        <div style="background: #FF71111A; border-radius: 12px; padding: 12px; margin-top: 12px;">
                            <div style="font-weight: 700; font-size: 12px; margin-top: 2px;">확인이 필요한 부분</div>
                            <div style="font-weight: 700; color: var(--color-main); margin-top: 10px; margin-bottom: 2px;">엘리트 인증사진 부적합</div>
                        </div>
                        <div @click="showRequestWriteForm" style="margin-top: 20px;" class="common_btn">입단 요청서 작성하기</div>
                        <div @click="changeConfirmState" style="margin-top: 10px; color: #808080; line-height: 24px; font-size: 12px; font-weight: 500; text-decoration: underline;">둘러보기</div>
                    </div>
                </template>
                <template v-if="type === MEMBER_POPUP_TYPE.EXTINCTION">
                    <div style="text-align: center;">
                        <div>
                            <img style="width: 137px;" :src="require('@/assets/img/extinction_scout.png')" alt="">
                        </div>
                        <div style="margin-top: 10px; font-weight: 700; font-size: 20px; line-height: 28px;">스카우트권 소멸까지 7일 남았어요!</div>
                        <div style="margin-top: 20px; color: #808080; font-size: 14px; line-height: 24px;">
                            다음 정기 결제일까지 딱 7일 남았습니다.<br>
                            사용하지 않은 잔여 스카우트권은 이월되지 않으니,<br>
                            소멸되기 전에 서둘러 유소년 선수들을 찾아보세요! 🏃‍♂️
                        </div>
                        <div style="margin-top: 20px; background-color: var(--color-main);" class="common_btn">이적시장으로 가기</div>
                        <div style="margin-top: 10px; color: #808080; line-height: 24px; font-size: 12px; font-weight: 500; text-decoration: underline;">잔여량 먼저 확인하기</div>
                    </div>
                </template>
                <template v-if="type === SCOUT_POPUP_TYPE.SEND_REQUEST">
                    <div style="text-align: center;">
                        <div>
                            <img style="width: 100px;" :src="require('@/assets/img/send_secret_request.png')" alt="">
                        </div>
                        <div style="margin-top: 10px; font-weight: 700; font-size: 20px; line-height: 28px;">선수에게 열람 요청을 보냈어요!</div>
                        <div style="margin-top: 10px; color: #808080; font-size: 14px; line-height: 24px; font-weight: 500;">
                           선수의 답변이 도착하면 알림으로<br>가장 먼저 알려드릴게요.
                        </div>
                        <div style="margin-top: 10px; color: var(--color-main); font-size: 14px; line-height: 24px; font-weight: 700;">
                           요청만으로는 절대 결제가 진행되지 않으니,<br>다른 선수들에게도 마음껏 제안해 보세요!
                        </div>
                        <div @click="btnClickAction" style="margin-top: 10px; background-color: var(--color-main);" class="common_btn">이적시장으로 가기</div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { INSTA_POPUP_TYPE, MEMBER_POPUP_TYPE, SCOUT_POPUP_TYPE } from '@/Constants'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'MemberPopupList',
    props: {
        type: {
            type: [String, Number],
            default: -1,
        },
        member_popup_idx: {
            type: [String, Number],
            default: -1,
        },
        btnClickAction: {
            type: Function,
            default: () => {},
        }
    },
    data() {
        return {
            INSTA_POPUP_TYPE: INSTA_POPUP_TYPE,
            MEMBER_POPUP_TYPE: MEMBER_POPUP_TYPE,
            SCOUT_POPUP_TYPE: SCOUT_POPUP_TYPE,
        }
    },
    methods: {
        async showRequestWriteForm() {
            await this.changeConfirmState()
            this.$GlobalStore.addModal('SelectPlayerType', {})
        },
        confirm() {
            this.$GlobalStore.closeLastModal()
        },
        async changeConfirmState() {
            if (this.member_popup_idx === -1) {
                this.$GlobalStore.closeLastModal()
                return
            }
            const formData = new FormData()
            formData.append('member_popup_idx', this.member_popup_idx)
            const res = await this.$Axios.post('/api/member/popup/confirm', formData)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal()
            }
        }
    }
}
</script>

<style scoped>
.common_btn {
    padding: 16px 0;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
}
</style>